const menu = [
    {
        name: 'Home',
        icon: 'home',
        path: '/',
        submenus: []
    },
    {
        name: 'Dashboard',
        icon: 'tachometer-alt',
        path: '/administration/dashboard',
        submenus: []
    },
    {
        name: 'Users',
        icon: 'user',
        path: '/administration/users',
        submenus: []
    },
    {
        name: 'Referral % and Commission %',
        icon: 'people-arrows',
        path: '/administration/referrals-list',
        submenus: []
    },
    {
        name: 'Creator Sales Boost with SUs',
        icon: 'people-arrows',
        path: '/administration/creator-sales-boost',
        submenus: [
            {
                name: 'Add Followers',
                icon: 'list',
                path: '/administration/creator-sales-boost',
                submenus: []
            },
            {
                name: 'Edit Followers',
                icon: 'list',
                path: '/administration/edit-followers',
                submenus: []
            }
        ]
    },
    {
        name: 'Creators',
        icon: 'users',
        path: '',
        submenus: [
            {
                name: 'PU Earning List',
                icon: 'list',
                path: '/administration/pu-earnings',
                submenus: []
            },
            {
                name: 'Suggested Creators',
                icon: 'users',
                path: '/administration/suggested-creators',
                submenus: []
            },
            {
                name: 'PU Payout',
                icon: 'money-check-alt',
                path: '/administration/pu-payout',
                submenus: []
            },
            {
                name: 'Email SUs Promo',
                icon: 'envelope',
                path: '/administration/email-sus-promo',
                submenus: []
            },
            {
                name: 'Download Post Medias',
                icon: 'download',
                path: '/administration/download-post-medias',
                submenus: []
            },
            {
                name: 'Download Stash Medias',
                icon: 'download',
                path: '/administration/download-stash-medias',
                submenus: []
            },
        ]
    },
    {
        name: 'Subscribers',
        icon: 'user-friends',
        path: '',
        submenus: [
            {
                name: 'SU Payment History',
                icon: 'history',
                path: '/administration/subscriber-payment-history',
                submenus: []
            },
            {
                name: 'User Transactions',
                icon: 'hand-holding-usd',
                path: '/administration/transactions',
                submenus: []
            }
        ]
    },
    {
        name: 'Tools',
        icon: 'tools',
        path: '',
        submenus: [
            {
                name: 'Import Welcome Messages',
                icon: 'file-import',
                path: '/administration/import-welcome-messages',
                submenus: []
            },
            {
                name: 'Exchange Rate USD to AUD API',
                icon: 'exchange-alt',
                path: '/administration/exchange-rate',
                submenus: []
            },
            {
                name: 'Cleanup Server Media Files Not Used by PUs',
                icon: 'tools',
                path: '/administration/cleanup-server-media',
                submenus: []
            }
        ]
    },
    {
        name: 'System Global Settings',
        icon: 'cogs',
        path: '/administration/system-global-settings',
        submenus: []
    },
    {
        name: 'Cron Jobs',
        icon: 'clock',
        path: '',
        submenus: [
            {
                name: 'Scheduled Posts',
                icon: 'clock',
                path: '/administration/crons/scheduled-posts',
                submenus: []
            },
            {
                name: 'Mail Notifications',
                icon: 'clock',
                path: '/administration/crons/mail-notifications',
                submenus: []
            },
            {
                name: 'Subscription Price Change',
                icon: 'clock',
                path: '/administration/crons/price-changes',
                submenus: []
            },
            {
                name: 'Pause Lists',
                icon: 'clock',
                path: '/administration/crons/pause-lists',
                submenus: []
            },
            {
                name: 'Pause Lists',
                icon: 'clock',
                path: '/administration/crons/pause-lists',
                submenus: []
            }
        ]
    },
    {
        name: 'Terms & Conditions',
        icon: 'file',
        path: '/administration/terms',
        submenus: []
    },
    {
        name: 'Privacy Policy',
        icon: 'file',
        path: '/administration/privacy-policy',
        submenus: []
    }
];

export default menu;
